import styled from '@emotion/styled';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import slice from 'lodash/slice';

import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import CardFull from 'src/section-events/events12/components/cards/card-full';
import CardV from 'src/section-events/events12/components/cards/card-v';
import { GET, GET_ARTICLES } from 'src/services';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
// import useResponsive from 'src/utils/devices';
import { convertObjPath } from 'src/utils/helper';

function sectionEventOne() {
    const router = useRouter();
    // const responsive = useResponsive();
    const [res, setRes] = useState([]);
    const [resTag, setResTag] = useState([]);
    const [resVideo, setResVideo] = useState([]);



    useEffect(() => {
        const resData = async () => {
            const data = await GET('/api/datasets');
            // const convert = convertDatasets(data, 'section-event-politics-new', false);
            const convert = convertDatasets(data, 'section-event-one', false);
            setRes(convert);
        };
        resData();
    }, []);

    const background = convertDatasets(res?.[0], 'background', true);
    const backgroundBackDrop = convertDatasets(res?.[0], 'background-back-drop', true);
    const titleOne = convertDatasets(res?.[0], 'title-1', true);
    const titleTwo = convertDatasets(res?.[0], 'title-2', true);
    const dataOne = convertDatasets(res?.[0], 'detail-1', true);
    const dataTwo = convertDatasets(res?.[0], 'detail-2', true);
    const link = convertDatasets(res?.[0], 'link1', true);
    const imageLeft = convertDatasets(res?.[0], 'image-left', true);
    const imageTopLeft = convertDatasets(res?.[0], 'image-top-left', true);
    const titleHeader1 = convertDatasets(res?.[0], 'title-header-1', true);
    const titleHeader2 = convertDatasets(res?.[0], 'title-header-2', true);
    const titleHeader3 = convertDatasets(res?.[0], 'title-header-3', true);

    useEffect(() => {
        const resData = async () => {
            const data =
                !isEmpty(dataOne) &&
                (await GET_ARTICLES(
                    `/api/search/tag${convertObjPath({
                        name: dataOne
                    })}`,
                    false,
                    false
                ));
            if (!isEmpty(data)) {
                setResVideo(data);
            }
        };
        resData();
    }, [dataOne]);

    useEffect(() => {
        const resData = async () => {
            const data =
                !isEmpty(dataTwo) &&
                (await GET_ARTICLES(
                    `/api/search/tag${convertObjPath({
                        name: dataTwo
                    })}`,
                    false,
                    false
                ));
            if (!isEmpty(data)) {
                setResTag(data);
            }
        };
        resData();
    }, [dataTwo]);

    if (isEmpty(res)) {
        return (<></>);
    }
    else {
        return (
            <SectionWrapper background={background}>
                <div className='container main-wrapper'>
                    <div className='background-overlay'></div>
                    <div className='head-wrapper'>
                        <div className='head-title-wrapper'>
                            <img className='image-top-left' src={imageTopLeft} alt='header' aria-label='header-icon' width='100%' height='100%' title='header-icon' />
                            <a href={link ? link : '#'}>
                                <label>{titleHeader1}</label>
                                <label>
                                    {titleHeader2}
                                    <strong>{titleHeader3}</strong>
                                </label>
                            </a>
                        </div>
                    </div>
                    <div className='content-wrapper'>
                        <div className='block-1'>
                            {!isEmpty(backgroundBackDrop) ? <img src={backgroundBackDrop} alt='background-back-drop' width='100%' height='100%' className='background-back-drop' /> : null}
                            <img className='manument-logo' src={imageLeft} />
                        </div>
                        {!isEmpty(resVideo) && (
                            <div className='block-2'>
                                <div className='block-text'>
                                    <h2>{titleOne}</h2>
                                    <p className='view-all-mobile'>
                                        <a href={`/tags/${dataOne}`}>อ่านทั้งหมด</a>
                                        <div className='on-top'>top</div>
                                    </p>
                                </div>
                                {map(slice(resVideo, 0, 1), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardFull
                                            key={index}
                                            data={element}
                                            showFooter={false}
                                            showBlurb={false}
                                            showTitle={false}
                                            showBadge={false}
                                            // external={true}
                                            // linkExternal={link}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '1',
                                                    heading: `${convertDatasets(res?.[0], 'title-1', true)}`,
                                                    title: element?.title,
                                                    index: index + 1
                                                }
                                            }}
                                        />

                                    </div>
                                ))}
                                {map(slice(resVideo, 1, 3), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardV
                                            data={element}
                                            showBadge={false}
                                            showBlurb={false}
                                            showTitle={true}
                                            showPublishDate={true}
                                            showCountView={false}
                                            showTimeAgo={true}
                                            showFooter={false}
                                            // target={'blank'}
                                            // externalLink={true}
                                            // linkExternal={link}
                                            // external={true}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '1',
                                                    heading: `${convertDatasets(res?.[0], 'title-1', true)}`,
                                                    title: element?.title,
                                                    index: index + 2
                                                }
                                            }}
                                        />

                                    </div>
                                ))}
                            </div>)}
                        {!isEmpty(resVideo) && (
                            <div className='block-2-mb'>
                                <div className='block-text'>
                                    <h2>{titleOne}</h2>
                                    <p className='view-all-mobile'>
                                        <a href={`/tags/${dataOne}`}>อ่านทั้งหมด</a>
                                        <div className='on-top'>top</div>
                                    </p>
                                </div>
                                {map(slice(resVideo, 0, 2), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardFull
                                            key={index}
                                            data={element}
                                            showFooter={false}
                                            showBlurb={false}
                                            showTitle={false}
                                            showBadge={false}
                                            // external={true}
                                            // linkExternal={link}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '1',
                                                    heading: `${convertDatasets(res?.[0], 'title-1', true)}`,
                                                    title: element?.title,
                                                    index: index + 1
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                        {!isEmpty(resTag) && (
                            <div className='block-3'>
                                <div className='block-text'>
                                    <h2>{titleTwo}</h2>
                                    <p className='view-all-mobile'>
                                        <a href={`/tags/${dataTwo}`}>อ่านทั้งหมด</a>
                                        <div className='on-top'>top</div>
                                    </p>
                                </div>
                                {map(slice(resTag, 0, 1), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardFull
                                            key={index}
                                            data={element}
                                            showFooter={false}
                                            showBlurb={false}
                                            showTitle={false}
                                            showBadge={false}
                                            // external={true}
                                            // linkExternal={link}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '2',
                                                    heading: `${convertDatasets(res?.[0], 'title-2', true)}`,
                                                    title: element?.title,
                                                    index: index + 1
                                                }
                                            }}
                                        />

                                    </div>
                                ))}
                                {map(slice(resTag, 1, 3), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardV
                                            data={element}
                                            showBadge={false}
                                            showBlurb={false}
                                            showTitle={true}
                                            showPublishDate={true}
                                            showCountView={false}
                                            showTimeAgo={true}
                                            showFooter={false}
                                            // target={'blank'}
                                            // externalLink={true}
                                            // linkExternal={link}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '2',
                                                    heading: `${convertDatasets(res?.[0], 'title-2', true)}`,
                                                    title: element?.title,
                                                    index: index + 2
                                                }
                                            }}
                                        />

                                    </div>
                                ))}
                            </div>)}
                        {!isEmpty(resTag) && (
                            <div className='block-3-mb'>
                                <div className='block-text'>
                                    <h2>{titleTwo}</h2>
                                    <p className='view-all-mobile'>
                                        <a href={`/tags/${dataTwo}`}>อ่านทั้งหมด</a>
                                        <div className='on-top'>top</div>
                                    </p>
                                </div>
                                {map(slice(resTag, 0, 4), (element: any, index: any) => (
                                    <div key={index} className={`card-item --item-${index + 1}`}>
                                        <CardV
                                            data={element}
                                            showBadge={false}
                                            showBlurb={false}
                                            showTitle={true}
                                            showPublishDate={true}
                                            showCountView={false}
                                            showTimeAgo={true}
                                            showFooter={false}
                                            // target={'blank'}
                                            // externalLink={true}
                                            // linkExternal={link}
                                            // external={false}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                type: DATALAYER_TYPE.TRACK_POSITION,
                                                router: router.pathname,
                                                section: 'event',
                                                position: 'ใต้:header',
                                                data: {
                                                    block: '2',
                                                    heading: `${convertDatasets(res?.[0], 'title-2', true)}`,
                                                    title: element?.title,
                                                    index: index + 1
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </SectionWrapper>
        );
    }

}
interface IStyled {
    background?: any;
}
const SectionWrapper = styled.div<IStyled>`
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: auto;
    background-image: url(${props => props.background});
    background-size: cover;
    padding-bottom: 30px;
    padding-top: 20px;
    @media (max-width: 992px) {
        padding-bottom: 50px;
        padding-top: 20px;
    }

    .background-overlay {
        position: absolute;
        bottom: -30px;
        width: 100%;
        height: 100%;
        background: rgb(0,0,0);
        background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 60%);
        z-index: 1;
    }
    
    .background-img-desktop {
        width: 100%;
        height: auto;
    }
  
    .main-wrapper {
        width: 100%;
        position: relative;
        .head-wrapper {
            position: relative;
            height: auto;
            display: flex;
            justify-content: right;
            gap: 20px;
                @media (max-width: 768px) {
                    z-index: 1;
                }
            .head-title-wrapper {
                display: flex;
                width: 65%;
                justify-content: center;
                align-items: center;
                
                @media (max-width: 768px) {
                    width: 100%;
                }
            }
            .image-top-left {
                width: 200px;
                height: auto;
                @media (max-width: 1024px) {
                        font-size: 180px;
                    }
                @media (max-width: 768px) {
                    width: 150px;
                }
            }
            a {
                label { 
                    display: block;
                    font-size: 40px;
                    font-weight: normal;
                    font-weight: 100;
                    color: #fff;
                    @media (max-width: 1024px) {
                        font-size: 28px;
                    }
                    @media (max-width: 768px) {
                        font-size: 22px;
                    }
                }
                strong {
                    font-size: 68px;
                    font-weight: bold;
                    color: #FF0000;
                    @media (max-width: 1024px) {
                        font-size: 46px;
                    }
                    @media (max-width: 768px) {
                        font-size: 26px;
                    }
                    
                }
            }
        }      
        .content-wrapper {
            /* position: relative; */
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 20px;
            @media (max-width: 992px) {
                flex-direction: column;
                gap: 15px;
            }
            .block-text {
                width: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                p,
                a {
                    text-align: end;
                    font-family: var(--front-primary), sans-serif;
                    color: #fff;
                    font-size: 12px;
                    font-weight: 200;
                    margin-bottom: 15px;
                    transition: all 0.5s ease-in-out;
                    position: relative;
                    &:hover {
                    color: #c9203b;
                    }
                    a {
                    background-color: #c9203b;
                    padding: 2px 10px 2px 30px;
                    border-radius: 20px;
                    &:hover {
                        background-color: #fff;
                    }
                    }
                    .on-top {
                    position: absolute;
                    top: -2px;
                    padding: 2px 20px;
                    border-radius: 20px;
                    right: 80px;
                    color: #c9203b;
                    background-color: #c9203b;
                    box-shadow: rgba(0, 0, 0, 0.8) 2px 0px 10px;
                    border: #831729 px solid #000;
                    }
                }
            }
            h2 {
            font-size: 20px;
            font-weight: 500;
            border-left: 8px solid #c9203b;
            line-height: 1;
            padding: 2px 15px;
            color: #fff;
            width: max-content;
            margin-bottom: 15px;
            @media (max-width: 768px) {
            font-size: 18px;
            padding: 2px 10px;
            }
            @media (max-width: 350px) {
            font-size: 14px;
            }
        }
            .block-1 {
                width: 40%;
                /* position: relative; */
                margin-bottom: -30px;
                img {
                    &.background-back-drop {
                        position: absolute;
                        width: 600px;
                        top: -20px;
                        mix-blend-mode: lighten;
                        @media (max-width: 768px) {
                            width: 450px;
                        }
                    }
                }
                .manument-logo {
                    position: absolute;
                    width: 576px;
                    bottom: -30px;
                    object-fit: cover;
                    @media (max-width: 1024px) {
                        width: 475px;
                    }
                    @media (max-width: 768px) {
                        width: 325px;
                    }
                }
            }
            .block-2 {
                margin-right: 20px;
            }
            .block-2, .block-3 {
                width: 35%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                z-index: 1;
                @media (max-width: 992px) {
                    justify-content: space-around;
                    }
                gap: 15px;
                .card-item {
                    &:nth-child(2) {
                        width: 100% !important;
                    }
                    width: 48% !important;
                    @media (max-width: 1200px) {
                        width: 46% !important;
                    }
                }
                @media (max-width: 992px) {
                    width: 100%;
                    display: none;
                }
            }
        }
        .block-2-mb, .block-3-mb {
            display: none;
            @media (max-width: 992px) {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                gap: 10px;
                z-index: 1;
                }
            .card-item {
                @media (max-width: 992px) {
                    width: 48% !important;
                }
            }
        }
    }

`;
export default sectionEventOne;